export const environment = {
  production: true,
  baseUrl:'https://api-demo.petrieai.com/',
  calendlyToken:'eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiUEFUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNzM1NzQ3MTYzLCJqdGkiOiIxZTY3NDBlZC1hZmM3LTQ0YWEtYjYxMy1hZGMwN2Y4NTY5NzYiLCJ1c2VyX3V1aWQiOiJkZmJkY2MwNC0xYzBkLTQ3ODYtODc0Ny1hMzdkZGRiODBjM2QifQ.NCQJ_ooqimsnIWHTN0785Zrhbgh3mE36yUemaCYocMWrGjpoH6yH-87Xd8le9A3z2a_Z2oXGA1T7U1_SN2UNqA',
  calendlyUrl: 'https://api.calendly.com/scheduled_events',
  calendlyEventDetail: 'https://api.calendly.com/scheduled_events',
  dialogFlowAgentId: '66a6cc72-7b70-43e2-b77c-e66639549a2f', // Petrie-Open-AI For Staging
  impersonateEnabled: false,
  impersonateAsSuperAdmin: false,
  impersonateDomain: '',
  superAdminDomain: 'admin-demo.petrieai.com',
  widgetMode: 'stage',
  socketServiceUrl: 'https://socket-demo.petrieai.com',
}
